import { formatter } from "../../core/helpers/formatter";
import { MetricColor, type TokenDO, type TokenData } from "../models/tokenDO.models";

export const buildTokenData = (tokenDO: TokenDO): TokenData => {
    const data = tokenDO.data;

    return {
        price: formatter.formatPrice(data.price),
        percent_change_24h: formatter.formatPercentage(data.percent_change_24h),
        market_cap: formatter.formatLargeNumber(data.market_cap),
        fully_diluted_market_cap: formatter.formatLargeNumber(data.fully_diluted_market_cap),
        volume_24h: formatter.formatLargeNumber(data.volume_24h),
        market_cap_dominance: formatter.formatPercentage(data.market_cap_dominance),
    } as TokenData;
};

export const getMetricColor = (tokenDataItem: TokenData, metric: keyof TokenData) => {
    const numericValue = parseFloat(tokenDataItem[metric]);

    if (Number.isNaN(numericValue)) {
        return MetricColor.neutral;
    }

    if (numericValue === 0) {
        return MetricColor.neutral;
    }

    return numericValue > 0 ? MetricColor.positive : MetricColor.negative;
};

